import { ODOO_WAREHOUSE_IDS } from "AppSettings";

export function validateProductCountry(product, warehouseId) {
  if (!product) return true;

  const numberWarehouseId = Number(warehouseId);

  if (
    numberWarehouseId === ODOO_WAREHOUSE_IDS.CHINA &&
    product.countryCodeOfOrigin !== "CN"
  ) {
    return false;
  }
  if (
    numberWarehouseId === ODOO_WAREHOUSE_IDS.CAMBODIA &&
    product.countryCodeOfOrigin !== "KH"
  ) {
    return false;
  }
  return true;
}

export function buildOtherProductSalesPricesMap(plan) {
  let parentPlanProductSalesPrices = {};
  const parent = plan.parent;
  const finalLines = parent
    ? [
        ...parent.lines,
        ...parent.children.reduce((acc, child) => {
          return [...acc, ...child.lines];
        }, []),
      ]
    : [];

  parentPlanProductSalesPrices = finalLines.reduce((acc, line) => {
    if (
      line.product &&
      line.salesPrice !== null &&
      line.salesPrice !== undefined &&
      line.salesPrice !== ""
    ) {
      const salesPrice = parseFloat(line.salesPrice);
      const discountPercentage = parseFloat(line.discountPercentage) || 0;

      if (!Number.isNaN(salesPrice)) {
        const salesPriceItem = { salesPrice, discountPercentage };
        if (line.product.id in acc) {
          acc[line.product.id].push(salesPriceItem);
        } else {
          acc[line.product.id] = [salesPriceItem];
        }
      }
    }
    return acc;
  }, {});

  return parentPlanProductSalesPrices;
}

export function computePlanLine({
  line,
  pricelist,
  pricelistProductIds,
  requiredCertificateTypes,
  parentPlanProductSalesPrices,
  planType,
  odooSalesOrderWarehouseId,
}) {
  console.log("requiredCertificateTypes", requiredCertificateTypes);

  const product = line.product;

  let isProductActive = true;
  let inPricelist = false;
  let priceConfirmed = false;
  let validCountry = false;
  let validQty = true;
  let validCPSC = true;
  let validGMARK = true;
  let otherPrices = null;
  let hasDifferentPrice = false;
  let validForIncOdoo = true;

  if (product) {
    // Check if product validation fields
    isProductActive = product.isActive;

    if (planType === "AB_INTERNAL_TRANSFER") {
      inPricelist = true;
      priceConfirmed = true;
    } else {
      inPricelist = pricelistProductIds.includes(product.id);
      if (inPricelist) {
        const pricelistItem = pricelist.latestPrices.find(
          (p) => p.product.id === product.id,
        );
        if (pricelistItem) {
          priceConfirmed = pricelistItem.state === "CONFIRMED";
        }
      }
    }

    validCountry = validateProductCountry(
      line.product,
      odooSalesOrderWarehouseId,
    );

    validQty = line.qty % product.itemsPerSet === 0;

    if (requiredCertificateTypes.includes("CPSC")) {
      validCPSC = product.cpscProduct != null;
    }
    if (requiredCertificateTypes.includes("GMARK")) {
      const complianceCertificates = product.complianceCertificates || [];
      validGMARK =
        complianceCertificates.filter((i) => i.certificateType === "GMARK")
          .length > 0;
    }

    if (parentPlanProductSalesPrices[line.product.id]) {
      const currentSalesPrice = parseFloat(line.salesPrice);
      const currentDiscountPercentage =
        parseFloat(line.discountPercentage) || 0;

      otherPrices = parentPlanProductSalesPrices[line.product.id]
        .map((i) => `${i.salesPrice} (${i.discountPercentage}% off)`)
        .join(", ");
      hasDifferentPrice = !parentPlanProductSalesPrices[line.product.id].some(
        (i) =>
          i.salesPrice === currentSalesPrice &&
          i.discountPercentage === currentDiscountPercentage,
      );
    }

    if (planType.includes("INC")) {
      validForIncOdoo = product.odooIdInc !== null;
    }
  }

  return {
    ...line,
    // validate fields
    inPricelist,
    priceConfirmed,
    validCountry,
    validQty,
    validCPSC,
    validGMARK,
    hasDifferentPrice,
    otherPrices,
    validForIncOdoo,
    isProductActive,
  };
}
